module.exports = __webpack_public_path__ + "img/alexis-franklin-untitled-2.232fbfd.jpg";